import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = ({ 
  items = [
    { question: 'What is ISOcore?', answer: 'ISOcore is a comprehensive ISO certification management platform that helps organizations streamline their certification processes.' },
    { question: 'How does the free trial work?', answer: 'Our 14-day free trial gives you full access to all features. No credit card required to start.' },
    { question: 'Which ISO standards are supported?', answer: 'We support all major ISO standards including ISO 9001, ISO 14001, ISO 45001, ISO 27001, and many more.' },
  ],
  className = '' 
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className={`space-y-4 ${className}`}>
      {items.map((item, index) => (
        <div 
          key={index}
          className="border border-border rounded-lg overflow-hidden"
        >
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex items-center justify-between p-4 text-left hover:bg-muted/50 transition-colors"
          >
            <span className="font-medium">{item.question}</span>
            <ChevronDown 
              className={`w-5 h-5 text-muted-foreground transition-transform ${
                openIndex === index ? 'rotate-180' : ''
              }`}
            />
          </button>
          {openIndex === index && (
            <div className="px-4 pb-4 text-muted-foreground">
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

FAQ.builderConfig = {
  props: {},
};

export default FAQ;
